module.exports = __webpack_public_path__ + "img/util-tab-1-title.75802d9e.svg";